const cadastro_ensino_ministrado = {
  path: "/cadastro-de-ensino-ministrado",
  redirect: "/cadastro-de-ensino-ministrado",
  meta: {
    breadCrumb: "Planejamento Matricula - Tabelas de Apoio ao Planejamento",
  },
  children: [
    {
      path: "/cadastro-de-ensino-ministrado",
      name: "cadastro-de-ensino-ministrado",
      meta: {
        allowedPermissions: ["geracao_de_vagas"],
        noAuth: true,
      },
      component: () =>
        import(
          "@/views/CadastroDeEnsinoMinistrado/CadastroDeEnsinoMinistradoHome.vue"
        ),
    },
    {
      path: "/cadastro-de-ensino-ministrado-novo",
      name: "cadastro-de-ensino-ministrado-novo",
      meta: {
        allowedPermissions: ["geracao_de_vagas"],
        noAuth: true,
      },
      component: () =>
        import(
          "@/views/CadastroDeEnsinoMinistrado/CadastroDeEnsinoMinistradoCreate.vue"
        ),
    },
    {
      path: "/cadastro-de-ensino-ministrado-editar/:id",
      name: "cadastro-de-ensino-ministrado-editar",
      meta: {
        allowedPermissions: ["geracao_de_vagas"],
        noAuth: true,
      },
      component: () =>
        import(
          "@/views/CadastroDeEnsinoMinistrado/CadastroDeEnsinoMinistradoUpdate.vue"
        ),
    },
  ],
};

export { cadastro_ensino_ministrado };
